import React, { Component } from "react";
import { Form, Field } from "redux-form";

class SigninForm extends Component {
  render() {
    const { error, handleSubmit } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <div className="pb2 f4 font-bold">{this.props.t("signin:identify")}</div>
        {error && <div className="form__error">{error}</div>}
        <Field
          className="form__field"
          name="email"
          component="input"
          type="text"
          placeholder={this.props.t("signin:emailAdressTextfield")}
        />
        <Field
          className="form__field form__field--margin-xs"
          name="password"
          component="input"
          type="password"
          placeholder={this.props.t("signin:passwordTextfield")}
        />
        <div className="clearfix">
          <div
            className="signin-modal__forgotten"
            onClick={this.props.openPasswordResetModal}
          >
            {this.props.t("signin:forgottenPassword")}
          </div>
        </div>
        <div className="tc mt3">
          <button className="button" type="submit">
            {this.props.t("signin:connectButton")}
            &nbsp;<i className="i-arrow-right f7" />
          </button>
        </div>
      </Form>
    );
  }
}

export default SigninForm;



// WEBPACK FOOTER //
// ./src/components/forms/SigninForm.js